export const TUTORIAL_TYPES = {
    BEGINNERS_GUIDE: 'beginners_guide',
    INTRO: 'intro',
    LESSON: 'lesson',
} as const;

export const TUTORIAL_NAMES = {
    BEGINNERS_GUIDE: 'beginners_guide',
} as const;
